import { Component, OnInit, ViewChild, ViewContainerRef, ElementRef, Output } from '@angular/core';
import { UsersService } from '../../../users/users.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { EventEmitter } from '@angular/common/src/facade/async';
import { modalSwal } from 'app/utils/helpers';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
declare const Cropper: any;

@Component({
  selector: 'app-profiles-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {

  protected config = {
    aspectRatio: 1 / 1,
    checkCrossOrigin: true,
    background: false,
    checkOrientation: true,
    scalable: true,
    rotatable: true
  };

  protected URL = window.URL;
  protected avatar = undefined;
  protected imageImport = 'assets/images/user.png';
  public onSave = false;
  public loadImage = false;
  public _cropper: any;

  activeCam: false;

  @Output() emitterAction: EventEmitter <any> = new EventEmitter <any>();

  @ViewChild('image') public image: ElementRef;
  @ViewChild('fileUploadImage') protected _fileUpload: ElementRef;

  constructor(
    private toastrAlertHelper: ToastrAlertHelper,
    
    protected _service: UsersService,
    public _loadig: T2LoadingService
  ) {

  }

  ngOnInit() {
  }


  /**
   * @name bringFileSelector
   * @description
   */
  public fileClick() {
    this._fileUpload.nativeElement.click();
  }

  /**
   * @name capture
   * @description Tomar foto
   */
  capture(data) {
    if (this._cropper) {
      this._cropper.destroy();
    }
    this.image.nativeElement.src = data.data;
    this._cropper = new Cropper(this.image.nativeElement, this.config);
    this.avatar = undefined;
    this.loadImage = true;
    this.activeCam = false;
  }

  /**
   * @description Importar foto
   * @param img
   */
  importImage(img) {
    const files = img.srcElement.files;
    this.loadImage = false;

    if (files && files.length) {
      this.activeCam = false;
      const file = files[0];
      if (/^image\/\w+$/.test(file.type)) {
        const data = this.URL.createObjectURL(file);
        if (this._cropper) {
          this._cropper.destroy();
        }
        this.image.nativeElement.src = data;
        this._cropper = new Cropper(this.image.nativeElement, this.config);
        this.avatar = undefined;
        this.loadImage = true;
      } else {
        this.toastrAlertHelper.warning('use jpg and / or png formats', 'Format not allowed');
      }
    }
  }

  /**
   * @name crop
   * @description Recortar foto
   */
  crop() {
    this.avatar = this._cropper.getCroppedCanvas({
      width: 300,
      height: 300
    }).toDataURL('image/jpeg', 60 / 100);
  }

  /**
   * @name Guardar foto
   * @description
   */
  save() {
    if (this.avatar) {
      this.onSave = true;
      this.emitterAction.emit({
        isUpdate: false,
        img: this.avatar,
        onSave: true
      });
      const img = this.avatar.split('base64,')[1];
      this._service
        .updateAvatar(img)
        .finally(() => this._loadig.hiden())
        .subscribe(
          (success) => {
            modalSwal('', 'success', success.message).then(() => {
              this.emitterAction.emit({
                isUpdate: true,
                img: this.avatar,
                onSave: this.onSave = false
              });
            });
          }, (error) => {
            modalSwal('Error', 'error', error.message).then(() => {
              this.emitterAction.emit({
                isUpdate: false,
                img: this.avatar,
                onSave: this.onSave = false
              });
            });
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/profiles/components/avatar/avatar.component.ts